module.exports = __webpack_public_path__ + "img/status-promotion.78435737.png";